import { useState, useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Carrer from "./assets/image/career.png";
import firebaseApp from "./Firecontact";
import { ToastContainer, toast } from "react-toastify";
import Footerbrand from "./Footerbrand";
import { Link } from "react-router-dom";

let DataCar = [];
const Career = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhoneNumber] = useState("");
  const [portfolioUrl, setPortfolioUrl] = useState("");
  const [selectedTechnology, setSelectedTechnology] = useState("");
  const [cvFile, setCvFile] = useState("");
  const [message, setMessage] = useState("");
  const [, SetCareer] = useState([]);
  const fileInputRef = useRef(null);

  const validateEmail = (email) => {
    // Use a regex pattern for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhoneNumber = (phonenumber) => {
    const phoneRegex = /^[0-9]+$/;
    return phoneRegex.test(phonenumber);
  };

  const handleFileChange = (file) => {
    // setshowLoader(true)
    const guid = () => {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return String(
        s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4()
      );
    };
    let myPromise = new Promise((resolve, reject) => {
      const myGuid = guid();
      const storageUrl = firebaseApp.storage(
        "gs://liontouchwebpark-a5ef9.appspot.com"
      );
      const storageRef = storageUrl.ref();
      const uploadTask = storageRef
        .child("Image")
        .child("CvDeveloper")
        .child(myGuid)
        .put(file[0]);
      uploadTask.on(
        "state_changed",
        () => { },
        (err) => {
          //catches the errors
          reject(err);
        },
        () => {
          firebaseApp
            .storage("gs://liontouchwebpark-a5ef9.appspot.com")
            .ref()
            .child("Image")
            .child("CvDeveloper")
            .child(myGuid)
            .getDownloadURL()
            .then((fireBaseUrl) => {
              resolve(fireBaseUrl);
            })
            .catch(() => {
            });
        }
      );
    });
    myPromise
      .then((url) => {
        setCvFile(url);
        // setshowLoader(false)
      })
      .catch(() => {
      });
  };

  const Careersub = () => {
    let Careerdata = {
      fullName: fullName,
      Email: email,
      Number: phonenumber,
      portfolioUrl: portfolioUrl,
      SelectedTechnology: selectedTechnology,
      CvFile: cvFile,
      Messsage: message,
      status: "New Lead",
      id: Date.now(),
      Date: new Date().toLocaleString(),
    };

    if (fullName === "") {
      alert("Please enter Full name");
      return;
    }
    if (!validateEmail(email)) {
      alert("Please enter a valid email address");
      return;
    }
    if (!validatePhoneNumber(phonenumber)) {
      alert("Please enter a valid phone number 0-9 & 10 Character");
      return;
    }
    if (portfolioUrl === "") {
      alert("Please enter a portfolioUrl link for Http//");
      return;
    }

    if (message === "") {
      alert("Please enter a message");
      return;
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }

    DataCar.push(Careerdata);

    let db = firebaseApp.firestore();
    db.collection("freelancers")
      .add(Careerdata)
      .then(() => {
        toast.success(
          "Thank you for applying! We will review your application and get back to you soon.",
          {
            position: "top-right",
            autoClose: 3000,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
        toast.error("Please try again", {
          position: "top-right",
          autoClose: 3000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });

    SetCareer(Careerdata);
    setFullName("");
    setEmail("");
    setPhoneNumber("");
    setPortfolioUrl("");
    setSelectedTechnology("");
    setMessage("");
    setCvFile("");
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };
  const handleTechnologyChange = (e) => {
    setSelectedTechnology(e.target.value);
  };

  return (
    <>
      <Header name="Carrer" />
      <ToastContainer />
      <section className="py-3 pt-4 section-background">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center align-self-center">
            <h3 className="text-dark fw-600 d-none d-md-block pb-0 ">
              Find hire your team in{" "}
              <span className="text-orange"> 24 hours</span>
            </h3>
            <ol className="d-flex justify-content-center align-items-center ">
              <li>
                <Link to={"/Home"} className="text-orange">
                  Home
                </Link>{" "}
              </li>{" "}
              <span className="mx-2">/</span>
              <li> Find hire your team in 24 hours </li>
            </ol>
          </div>
        </div>
      </section>

      <section className="pt-35 pb-35 px-2 px-lg-2">
        <div className="container p-3">
          <div className="row justify-content-center">
            <h2 className="mb-20 fs-2">Join Our Team Only Freelancers</h2>
            <div className="col-md-6">
              <div className="row mt-10">
                <div className="col-md-6">
                  <label className="text-dark mt-2 mb-1">Full Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label className="text-dark mt-2 mb-1">
                    Your Email Address*
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label className="text-dark mt-2 mb-1">Phone Number</label>
                  <input
                    maxLength={10}
                    type="text"
                    className="form-control"
                    value={phonenumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label className="text-dark mt-2 mb-1">Portfolio URL</label>
                  <input
                    type="text"
                    className="form-control"
                    value={portfolioUrl}
                    onChange={(e) => setPortfolioUrl(e.target.value)}
                  />
                </div>

                <div className="col-md-12">
                  <label className="text-dark mt-2 mb-1">
                    Only This Technologies
                  </label>
                  <select
                    id="inputState"
                    className="form-control"
                    value={selectedTechnology}
                    onChange={handleTechnologyChange}
                  >
                    <option value="" disabled>
                      Select Position
                    </option>
                    <option value="Frontend Developer">
                      Frontend Developer
                    </option>
                    <option value="Backend Developer">Backend Developer</option>
                    <option value="Full Stack Developer">
                      Full Stack Developer
                    </option>
                    <option value="MERN Stack Developer">
                      MERN Stack Developer
                    </option>
                    <option value="MEAN Stack Developer">
                      MEAN Stack Developer
                    </option>
                    <option value="React Developer">React Developer</option>
                    <option value="Angular Developer">Angular Developer</option>
                    <option value="Vue.js Developer">Vue.js Developer</option>
                    <option value="Node.js Developer">Node.js Developer</option>
                    <option value="Laravel Developer">Laravel Developer</option>
                    <option value="Python Developer">Python Developer</option>
                    <option value="Flutter Developer">Flutter Developer</option>
                    <option value="React Native Developer">
                      React Native Developer
                    </option>
                    <option value="Android Developer">Android Developer</option>
                    <option value="iOS Developer">iOS Developer</option>
                    <option value="UI/UX Designer">UI/UX Designer</option>
                    <option value="Web Designer">Web Designer</option>
                    <option value="WordPress Developer">
                      WordPress Developer
                    </option>
                    <option value="Shopify Developer">Shopify Developer</option>
                    <option value="SEO Specialist">SEO Specialist</option>
                    <option value="Digital Marketing Executive">
                      Digital Marketing Executive
                    </option>
                    <option value="Content Writer">Content Writer</option>
                    <option value="Graphic Designer">Graphic Designer</option>
                    <option value="Video Editor">Video Editor</option>
                    <option value="Business Development Executive">
                      Business Development Executive
                    </option>
                    <option value="Other (Mantion in Resume)">
                      Other (Mantion in Resume)
                    </option>
                  </select>
                </div>
                <label className="text-dark mt-2 mb-1">Upload CV</label>
                <div className="single-form">
                  <div className="upload-input">
                    <input
                      className="form-control"
                      type="file"
                      id="upload"
                      name="upload"
                      ref={fileInputRef}
                      onChange={(e) => handleFileChange(e.target.files)}
                    />
                  </div>
                </div>
                <div className="row pb-10">
                  <div className="col-12">
                    <label className="text-dark mt-2 mb-1">Message</label>
                    <textarea
                      className="form-control"
                      name="message"
                      id="message"
                      rows={4}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col" onClick={Careersub}>
                    <button type="button" className="btn-main w-100 w-md-25">
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 justify-content-center mt-3 align-self-center ">
              <img src={Carrer} className="w-100" alt="Carrer" />
            </div>
          </div>
        </div>
      </section>
      <Footerbrand />
      <Footer />
    </>
  );
};

export default Career;
